'use client';

import { useEffect, useRef, useState, type RefObject } from 'react';

export interface XYChartElementSize {
  width: number;
  height: number;
}

export interface UseXYChartElementSizeResult<ElementType extends HTMLElement> {
  ref: RefObject<ElementType | null>;
  size: XYChartElementSize;
}

export function useXYChartElementSize<
  ElementType extends HTMLElement,
>(): UseXYChartElementSizeResult<ElementType> {
  const ref = useRef<ElementType | null>(null);
  const [size, setSize] = useState<XYChartElementSize>({ width: 0, height: 0 });

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      const { width, height } = entry.contentRect;
      setSize({ width, height });
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return { ref, size };
}
